import { render } from "./ConfirmPopup.vue?vue&type=template&id=728c2fc4&scoped=true"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js"

import "./ConfirmPopup.vue?vue&type=style&index=0&id=728c2fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728c2fc4"]])

export default __exports__